import { render, staticRenderFns } from "./TestStatus.vue?vue&type=template&id=3b9589c1"
import script from "./TestStatus.vue?vue&type=script&lang=js"
export * from "./TestStatus.vue?vue&type=script&lang=js"
import style0 from "./TestStatus.vue?vue&type=style&index=0&id=3b9589c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports